/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Video_Export_Status_Export_Failed_With_ErrorInputs */



/**
* | output |
* | --- |
* | "Cannot export video: {error}" |
*
* @param {Video_Export_Status_Export_Failed_With_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_status_export_failed_with_error = /** @type {((inputs: Video_Export_Status_Export_Failed_With_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Status_Export_Failed_With_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Impossible d'exporter la video : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Videoexport fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile esportare il video: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Невозможно экспортировать видео: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se puede exportar el vídeo: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`无法导出视频：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ビデオをエクスポートできません: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`वीडियो निर्यात नहीं किया जा सकता: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não foi possível exportar o vídeo: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Cannot export video: ${i?.error}`)
});